import { render, staticRenderFns } from "./Supplies.vue?vue&type=template&id=8d5b2f44&scoped=true&"
import script from "./Supplies.vue?vue&type=script&lang=js&"
export * from "./Supplies.vue?vue&type=script&lang=js&"
import style0 from "./Supplies.vue?vue&type=style&index=0&id=8d5b2f44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d5b2f44",
  null
  
)

export default component.exports